import React from "react";
import { TMDB_IMG_BASE_URL } from "../utils/constants";
import StarIcon from "../assets/star.svg";

const MovieDetail = ({ movie }) => {
  if (movie === undefined) return null;
  const { title, overview, release_date, poster_path, vote_average } = movie;
  return (
    <div className="mx-auto p-2 grid grid-cols-4 text-white bg-black bg-opacity-80 w-full md:w-3/4">
      <div className="p-1 col-span-1">
        <img
          className="max-w-[75px] md:max-w-32 lg:max-w-36"
          src={TMDB_IMG_BASE_URL + poster_path}
        ></img>
      </div>
      <div className="p-2 col-span-3 flex flex-col justify-between">
        <h1 className="my-1 font-bold text-sm md:text-base lg:text-lg">
          {title}
        </h1>
        <p className="my-1 text-[10px] md:text-sm lg:text-lg">{overview}</p>
        <div className="my-1 flex justify-between text-xs md:text-base lg:text-xl">
          <div className="flex">
            <p className="mx-1">Rating: </p>
            {vote_average.toPrecision(2)}
            <img className="w-4 md:w-5 lg:w-6" src={StarIcon} alt="star" />
          </div>
          <div>
            <span>Release Date: </span>
            <span>{release_date}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieDetail;
